/**
 * Created by kairy on 24/03/18.
 */
export default (str) => {
    if (str) {
        let old = new RegExp(' ', 'g')
        let newstr = str.replace(old, '&nbsp;')
        // console.log(newstr)
        return newstr
    }
    return str
}



// WEBPACK FOOTER //
// ./src/filters/spaceReplace.js